export default "__VITE_ASSET__872184c4__"